export default __webpack_public_path__ + "static/media/selling-bg.e9043afe.png";